import { getStatusDefaults } from './statusDefaults';
// Status colours for the Deal Flow board (ClickUp-style lanes).
// A status may carry its own `color` (hex); otherwise it gets a stable default.

// Preset swatches, ClickUp's palette plus Backrr's indigo.
export const STATUS_PALETTE = [
    '#87909E', // grey
    '#444CE7', // Backrr indigo
    '#1090E0', // blue
    '#0F9D9F', // teal
    '#299764', // green
    '#59CE00', // lime
    '#F8AE00', // amber
    '#E16B16', // orange
    '#C62A2F', // red
    '#EE5E99', // pink
    '#AB4ABA', // purple
    '#A18072', // brown
];


// Custom statuses cycle through colours the built-ins don't use.
const CUSTOM_CYCLE = ['#AB4ABA', '#0F9D9F', '#299764', '#E16B16', '#EE5E99', '#A18072', '#444CE7', '#59CE00'];

const HEX = /^#([0-9a-f]{6})$/i;

export const isHexColor = (value) => HEX.test(String(value || ''));

export const statusColor = (status) => {
    if (isHexColor(status?.color)) return status.color;
    const builtIn = getStatusDefaults()[status?.value];
    if (builtIn) return builtIn.color;
    const order = Number(status?.display_order) || 0;
    return CUSTOM_CYCLE[Math.abs(order) % CUSTOM_CYCLE.length];
};

const toRgb = (hex) => {
    const n = parseInt(hex.slice(1), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

// WCAG 2.x relative luminance.
const luminance = (hex) => {
    const [r, g, b] = toRgb(hex).map((v) => {
        const c = v / 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// White text unless the colour is bright; ClickUp's cut-off (white on brown/green, dark on lime/yellow).
export const readableText = (hex) => (luminance(hex) > 0.4 ? 'rgba(0,0,0,0.87)' : '#FFFFFF');

// Lane tint: the colour at low opacity; light colours are darkened first so the tint still shows.
export const laneTint = (hex, alpha = 0.05) => {
    let [r, g, b] = toRgb(hex);
    if (luminance(hex) > 0.5) [r, g, b] = [r, g, b].map((v) => Math.round(v * 0.72));
    const a = hex.toUpperCase() === '#87909E' ? alpha * 2 : alpha;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};
